<script lang="ts" setup>
  import { useHttpClient, useRoute } from '@othercommerce/foundation';
  import { type PropType } from 'vue';
  import type { Wishlist } from '@storefront/types';

  const open = defineModel('open', { type: Boolean, required: false, default: false });

  const emit = defineEmits([
    'saved',
  ]);

  const route = useRoute();
  const http = useHttpClient();

  const props = defineProps({
    wishlist: { type: Object as PropType<Wishlist>, required: false },
  });

  function onSubmit(data: { name: string }) {
    if (props.wishlist) {
      return http.patch(route('web.account.wishlist.update', { wishlist: props.wishlist }), { name: data.name }).then(() => emit('saved'));
    } else {
      return http.post(route('web.account.wishlist.store'), { name: data.name }).then(() => emit('saved'));
    }
  }
</script>

<template>
  <UiModal medium v-model:open="open" class="wishlist-edit-modal" aria-describedby="wishlist-edit-modal-title">
    <FormController :data="wishlist" @submit="onSubmit" v-slot="{ processing, submit } ">
      <SfModalHeader v-model:open="open" headerType="span" headingStyle headingId="wishlist-edit-modal-title">
        <template v-if="wishlist">{{ $t('SHOP.WISHLIST.ACTION.EDIT_LIST') }}</template>
        <template v-else>{{ $t('SHOP.WISHLIST.ACTION.CREATE_LIST') }}</template>
      </SfModalHeader>
      <section class="wishlist-edit-modal__input">
        <SfFormInput :label="$t('SHOP.WISHLIST.LABEL.NAME')" name="name" required />
      </section>
      <UiButtonGroup end>
        <SfButton @click.prevent="open = false">
          {{ $t('SHOP.COMMON.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :loading="processing" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </UiButtonGroup>
    </FormController>
  </UiModal>
</template>
<style lang="scss">
  .wishlist-edit-modal__input {
    flex-grow: 1;
  }
</style>
